/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ScenarioMigrationResultDto } from '../models/ScenarioMigrationResultDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ScenarioMigrationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns ScenarioMigrationResultDto OK
     * @throws ApiError
     */
    public postApiHousingScenarioMigrationPreviewScenarioMigration(): CancelablePromise<ScenarioMigrationResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/ScenarioMigration/PreviewScenarioMigration',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @returns ScenarioMigrationResultDto OK
     * @throws ApiError
     */
    public postApiHousingScenarioMigrationExecuteScenarioMigration(): CancelablePromise<ScenarioMigrationResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/ScenarioMigration/ExecuteScenarioMigration',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
